var _polygon, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacetedPentagon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    id: "dia-faceted-pentagon",
    viewBox: "0 0 75.4345 71.7433",
    width: 100,
    height: 95,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    id: "fill_dia-faceted-pentagon",
    points: "37.717 4.014 3.818 28.644 16.767 68.495 58.668 68.495 71.616 28.644 37.717 4.014"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "shadow_dia-faceted-pentagon",
    fill: "currentColor",
    fillOpacity: 0.085,
    d: "M14.2891,21.036,3.818,28.644,16.767,68.495H58.668l3.3952-10.45C15.6632,60.612,14.2891,21.036,14.2891,21.036Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "stroke_dia-faceted-pentagon",
    fill: "currentColor",
    d: "M37.7168,0,0,27.4033l14.4072,44.34h46.62l14.4073-44.34ZM55.2739,33.3313,38.2168,20.9387V13.21L62.6614,30.97ZM27.1777,54.9189H48.2568l4.5144,6.253H22.6633Zm20.9717-1H27.2852L20.8369,34.0762l16.88-12.2647L54.5977,34.0762ZM20.1606,33.3313,12.7732,30.97,37.2168,13.21v7.7287ZM37.2168,11.9739,11.5913,30.5925,4.33,28.2719,37.2168,4.377Zm-17.364,22.31L26.3679,54.332l-4.5342,6.28L12.5173,31.939Zm2.0886,27.8885H53.4932l4.5651,6.3232H17.3762Zm27.1253-7.84,6.5151-20.0486,7.3354-2.3444L53.6008,60.6122Zm14.7766-23.74L38.2168,11.9739V4.377L71.1045,28.2719ZM4.0051,29.2185,11.344,31.564l9.7646,30.0526L16.573,67.899ZM58.8616,67.899l-4.5357-6.2824L64.0906,31.564l7.3388-2.3455Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacetedPentagon);
export default __webpack_public_path__ + "static/media/faceted-pentagon.83e6768a31436eddaa4b563cfbe11bce.svg";
export { ForwardRef as ReactComponent };